/* eslint react/jsx-props-no-spreading: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, Link } from 'react-router-dom';
import { getOperatingSystem } from '../../utils/system';

// Persists the query params of the current route through to the link
export function LinkWithQueryParams({ children, to, ...props }) {
  const { search } = useLocation();

  return (
    <Link to={to + search} {...props}>
      {children}
    </Link>
  );
}

LinkWithQueryParams.propTypes = {
  children: PropTypes.node,
  to: PropTypes.string.isRequired,
};

// Add a common download link component
function DownloadAppLink({ children }) {
  const OS = getOperatingSystem();
  const version = process.env.REACT_APP_VERSION;
  const downloadLinkEnvVariables = OS !== 'MacOS' ? {
    os: 'windows',
    app_name: process.env.REACT_APP_NODE_ENV === 'production'
      ? `Shoot+Setup+${version}.exe` : `Shoot+Staging+Setup+${version}.exe`,
  } : {
    os: 'mac',
    app_name: process.env.REACT_APP_NODE_ENV !== 'production'
      ? `Shoot+Staging-${version}.dmg` : `Shoot-${version}.dmg`,
  };
  const downloadLink = `${process.env.REACT_APP_DOWNLOAD_LINK}`
    .replace('{{ENV}}', process.env.REACT_APP_NODE_ENV)
    .replace('{{OS}}', downloadLinkEnvVariables.os)
    .replace('{{APP_NAME}}', downloadLinkEnvVariables.app_name);
  return (
    <a href={downloadLink} target="_blank" rel="noopener noreferrer">
      {children || 'Download App'}
    </a>
  );
}

DownloadAppLink.propTypes = {
  children: PropTypes.node,
};

export default DownloadAppLink;
